import type { ReasonToMessageMap } from "../common/types";
import type { MarketViewActionUnavailableReason } from "./types";

export const marketViewReasonToMessageMap: ReasonToMessageMap<MarketViewActionUnavailableReason> = {
	ACL_EDITOR_REQUIRED: (count) =>
		count === 1
			? `${count} market view is excluded because the user does not have the necessary permissions to perform this action.`
			: `${count} market views are excluded because the user does not have the necessary permissions to perform this action.`,
	ACL_OWNER_REQUIRED: () => "You are not the owner",
};
